import { gql } from '@apollo/client';

export const GET_BANNERS = gql`
  query GetBanners {
    banners(order_by: { createdAt: Asc }) {
      id
      title
      description
      badge
      imageUrl
      primaryText
      primaryLink
      secondaryText
      secondaryLink
      variant
      backgroundColor
      type
      intl
      contentId
    }
  }
`;
